export enum OfferTypeCodeEnum {
  Direct_Percentage_Discount = 'Direct_Percentage_Discount',
  Free_Product = 'Free_Product',
  Cash_back = 'Cash_back',
}
